/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type AirlineCheckInType = typeof AirlineCheckInType[keyof typeof AirlineCheckInType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AirlineCheckInType = {
  Online: 'Online',
  AtTheAirport: 'AtTheAirport',
} as const;
